import { Link } from 'react-router-dom';

// @mui material components
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';

// Material Dashboard components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';

// Authentication layout components
import BasicLayout from 'composites/BasicLayout';

// Image
import bgImage from 'assets/images/bg-sign-in-basic.jpeg';

function NotFound(): JSX.Element {
  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="warning"
          borderRadius="lg"
          coloredShadow="warning"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Page Not Found
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3} textAlign="center">
          <MDTypography variant="body1" mb={3}>
            The page you are looking for doesn't exist or has been moved.
          </MDTypography>
          <Grid container justifyContent="center">
            <Grid item>
              <MDButton
                component={Link}
                to="/home"
                variant="gradient"
                color="info"
              >
                Go to Home
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default NotFound;
